<template>
    <div class="notes-dialog">
        <el-dialog :visible.sync="notesOpen" 
        append-to-body
        width="80vw"
        :close-on-click-modal="true"
        class="send-modal">
            <div slot="title" class="bucket-header">
                <img class="event-chevron" style="width: 57px" :src="require('../image/ctc-event.png')" /> 
                {{ name }}
                <span class="bucket-provider">
                    {{ date }}
                </span>
                <span v-if="providerName" class="bucket-provider">
                    {{ providerName }}
                </span>
                <span class="flex-full"></span>
                <span v-if="oldNote" class="old-note">
                    Edited on {{ formatDateTime(oldNote.created) }} by {{ oldNote.created_by }}
                </span>

            </div>
            <p class="last-pushed-string">{{ lastPushedString }}</p>
            <div class="dialog-body">
                <div class="questionnaire-section">
                    <span class="questionnaire-title">{{ questionnaireTitle }}</span>
                    <span class="oval"></span>
                    <span class="questionnaire-date">Responded on {{ questionnaireDate }}</span>
                    <NoteActions
                        :emrCategory="emrCategory"
                        :hasPushIntegration="hasPushIntegration"
                        :hasNoteBeenEdited="hasNoteBeenEdited"
                        :combNoteDisabled="combNoteDisabled"
                        :savable="doesNoteSavedVersionExists"
                        :pushing="pushing"
                        :updating="updating"
                        :disable-push="hasNoteBeenEdited"
                        @update-chart-note="callUpdateChartNote"
                        @save-emr-note="saveEmrNote"
                        @emr-selected="emrSelected"
                        @new-emr-selected="onNewEmrSelected" />
                </div>
                <div class="notes">
                    <TextEdit 
                        :key="renderKey"
                        class="text-edit expanded"
                        :textEditId="schedule"
                        v-model="copyNotes"
                        @text-selected="partialNoteSelected"
                    ></TextEdit>
                </div>
            </div>
        </el-dialog>
        <button v-if="type === 'text'" @click="notesOpen = true" class="questionnaire-view-button" type="text" size="medium">
            <i class="el-icon-view"></i> View
        </button>
        <template v-else-if="type === 'icon'">
            <div class="saved-notes" v-if="savedCharts.length > 1">
                <SavedNotes
                    :savedCharts="savedCharts"
                    @open-notes="openOldNotes" />
            </div>
            <img v-else-if="type === 'icon'" @click="notesOpen = true;isOldNote = false;" class="expand-icon" :src="require('../image/expand-icon.png')" />
        </template>
        
    </div>
    
</template>

<script>
import { mapActions } from 'vuex'

import CopyMixin from './mixin/copy'

import TextEdit from '@/module/component/TextEdit'
import NoteActions from './NoteActions'
import SavedNotes from './SavedNotes'

import formatDateTime from '@/module/util/format-date-time'

export default {
    name: 'questionnaire-notes-dialog',

    mixins: [CopyMixin],

    props: {
        patient: {
            type: Object,
            required: true
        },
        notes: {
            type: String,
            required: true
        },
        questionnaireTitle: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        providerName: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        questionnaireDate: {
            type: String,
            required: true
        },
        lastPushedString: {
            type: String,
            required: true,
            default: ''
        },
        hasPushIntegration: {
            type: Boolean,
            required: true
        },
        emrCategory: {
            type: Array,
            required: true
        },
        provider: {
            type: String,
            required: true
        },
        eventId: {
            type: String,
            required: true
        },
        schedule: {
            type: String,
            required: true
        },
        combNoteDisabled:  {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: 'text'
        },
        savedCharts: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            notesOpen: false,
            copyNotes: this.notes.replaceAll('\n', '<br>'),
            pushing: false,
            copiedNote: null,
            partiallyCopiedNote: false,
            copiedNoteDupl: null,
            partiallyCopiedNoteDupl: false,
            showPopOver: false,
            selectedEMRData : {},
            renderKey: 0,
            foundEmpty: false,
            updating: false,
            oldNote: false
        }
    },

    methods: {
        ...mapActions('provider', ['pushNoteCategory', 'loadPatient', 'updateChartNote', 'pushNewNoteCategory']),
        formatDateTime,
        copyToClip() {
            this.copy(this.copyNotes)
        },
        
        emrSelected(data) {
            this.selectedEMRData = data
            if(this.partiallyCopiedNote && !this.partiallyCopiedNoteDupl) {
                this.showPopOver = true
                this.copiedNoteDupl = this.copiedNote
                this.partiallyCopiedNoteDupl = this.partiallyCopiedNote
            }
            else this.saveEmrNote(this.selectedEMRData)
        },
        saveEmrNote(emrData) {
            const queryData = {
                schedule: this.schedule,
                id: this.patient.id,
                provider: this.provider,
                emrs: [{
                    emr_category: emrData.emrId,
                    combined_notes: this.partiallyCopiedNoteDupl ? this.copiedNoteDupl.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '') : this.copyNotes.replace(/<\/?[Bb][Rr]>\s?/g, '\n').replace( /(<([^>]+)>)/ig, '')
                }]
            }
            this.pushing = true
            this.pushNoteCategory(queryData)
                .then((response) => {
                    if(this.partiallyCopiedNote) {
                        this.$message({
                            message: response.success ? ('Pushed to ' + emrData.emrTitle) : ('Failed to push to ' + emrData.emrTitle),
                            type: response.success ? 'success' : 'error'
                        })
                    } else {
                        this.notesOpen = false
                        this.$message({
                            message: response.description,
                            type: response.success ? 'success' : 'error'
                        })
                    }
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error(error.description)
                }).finally((_) => {
                    this.pushing = false
                    this.copiedNote = null
                    this.partiallyCopiedNote = false
                    this.copiedNoteDupl = null
                    this.partiallyCopiedNoteDupl = false
                    this.showPopOver = false
                    this.selectedEMRData = {}
                })
        },
        partialNoteSelected(partNote, noteId, clickedOut) {
            if(partNote == null && clickedOut) {
                this.copiedNote = null
                this.partiallyCopiedNote = false
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteDupl = false
            } else if(partNote == null && !clickedOut) {
                this.copiedNoteDupl = null
                this.partiallyCopiedNoteDupl = false
            } else {
                this.copiedNote = partNote.replaceAll('\n', '<br>')
                this.partiallyCopiedNote = true
                this.copiedNoteDupl = partNote.replaceAll('\n', '<br> <br>')
                this.partiallyCopiedNoteDupl = true
            }
        },
        confirmParPushEmr() {
            this.showPopOver = false
            this.copiedNoteDupl = this.copiedNote
            this.partiallyCopiedNoteDupl = this.partiallyCopiedNote
            this.saveEmrNote(this.selectedEMRData)
        },
        cancelParPushEmr() {
            this.showPopOver = false
            this.copiedNote = null
            this.partiallyCopiedNote = false
            this.copiedNoteDupl = null
            this.partiallyCopiedNoteDupl = false
        },
        /**
         * Update the chart note to a newer version
         */
        callUpdateChartNote() {
            this.updating = true
            this.updateChartNote({
                id: this.patient.id,
                provider: this.provider,
                questionnaire_id: this.eventId,
                update: this.copyNotes
            }).then((response) => {
                this.$message({
                    message: 'Changes saved successfully',
                    type: 'success'
                })
            }).catch((error) => {
                if(!error.success)
                    this.$message.error("Problem saving changes")
            }).finally((_) => this.updating = false)
        },
        onNewEmrSelected(emrData) {
            const query = {
                id: this.patient.id,
                provider: this.provider,
                emr_category: emrData.emrId,
                questionnaire: [this.eventId]
            }
            this.pushing = true  
            this.pushNewNoteCategory(query)
                .then((response) => {
                    this.$message({
                        message: `Pushed to ${emrData.emrTitle}`,
                        type: 'success'
                    })
                }).catch((error) => {
                    if(!error.success)
                        this.$message.error("Problem pushing to EMR")
                }).finally((_) => this.pushing = false)
        },
        openOldNotes(id) {
            const savedIndex = this.savedCharts.findIndex(chart => chart.id === id)
            if (savedIndex !== -1) {
                this.copyNotes = this.savedCharts[savedIndex].text.replaceAll('\n', '<br>')
                this.notesOpen = true
                this.oldNote = this.savedCharts[savedIndex]
            }
            this.renderKey++
        }
    },

    computed: {
        /**
         * Check if the notes have been edited
         */
        hasNoteBeenEdited() {
            const initialNote = this.notes.replaceAll('\n', '<br>')
            return this.copyNotes !== initialNote
        },
        /**
         * Check if the note has a saved version already available to
         * update, by checking `savedCharts`
         */
        doesNoteSavedVersionExists() {
            return this.savedCharts.length > 0
        },

    },

    components: {
        TextEdit,
        NoteActions,
        SavedNotes
    }
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.dialog-body {
    background-color: #F8F8F8;
    margin-top: -5px;
    width: calc(80vw - 40px);
    padding: 20px;
    border-radius: 7px;
}

.el-checkbox {
    font-weight: 600;
}

.bucket-header {
    background-color: transparent;
}
.notes-dialog {
    margin-top: -20px;
}
.last-pushed-string {
    float: right;
    margin-top: -27px;
    font-size: 12px;
    color: #666666;
}
.questionnaire-view-button, .questionnaire-view-button:hover {
    float: right;
    background-color: #EEEEEE;
    font-size: 13px;
    border: none;
    margin-left: 10px;
    border-radius: 5px;
    padding: 6px 8px !important;
    i {
        font-size: 13px;
		margin-right: 3px;
    }
}
.expand-icon {
    height: 20px;
    width: 20px;
    float: right;
    cursor: pointer;
}
.notes {
    background-color: #ffffff;
    border-radius: 10px;
    padding-top: 12px;
    padding-bottom: 12px;
    line-height: 24px;
}
.event-head {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 10px;
    span:first-child {
        padding-left: 0;
    }
    span {
        padding: 0px 12px;
    }
}
.questionnaire-section {
    word-break: break-word;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
}


.inl-blk {
    display: inline-block;
}
.pop-btn-grp {
    margin-left: 20px
}
.saved-notes {
    float: left;
    margin-top: 0;
}
.old-note {
    font-weight: 400;
    font-size: 13px;
    color: #666666;
}
</style>


<style scoped>
.send-modal >>> .el-dialog__headerbtn {
    top: 0px;
    right: -40px;
    background-color: #ffffff;
    border-radius: 50%;
    padding: 5px 5px 3px 5px;
}
.send-modal >>> .el-dialog__close:hover {
	font-weight: bold;
}
.send-modal >>> .el-dialog__close {
	color: #333333;
    font-size: 15px;
    font-weight: 500;
}
.send-modal >>> .el-dialog__headerbtn:hover .el-dialog__close {
	font-size: 15px;
    font-weight: 500;
}
.cust-pop-class {
    min-width: 520px;
}
.text-edit >>> b{
    color: #833e93;
}
.footer-btn >>> span {
    display: flex;
    align-items: center;
}
</style>
